module.exports = __webpack_public_path__ + "m-search-1-358aef42.svg";